import React, { useCallback } from 'react';
import Modal from '@common/modal';
import DateFormat from '@utils/date/format';
import classnames from 'classnames/bind';
import styles from './noticeConfirmModal.module.scss';

const cx = classnames.bind(styles);

interface NoticeModalProps {
  useYn: boolean;
  type: 'SMS' | 'EMAIL';
  onClose: () => void;
}

const NoticeConfirmModal = ({ useYn, type, onClose }: NoticeModalProps) => {
  const state = useYn ? '수신동의' : '수신거부';
  const noticeTarget = type === 'SMS' ? 'SMS' : '이메일';
  const time = DateFormat.format(new Date(), 'yyyy년 MM월 dd일 HH시 mm분');

  const onClickCloseBtn = useCallback(() => {
    if (onClose) onClose();
  }, []);

  return (
    <Modal visible={true}>
      <div className={cx('layerNotice')}>
        <div className={cx('confirmInfoArea')}>
          <div className={cx('confirmInfoInner')}>
            <span className={cx('infoTitle')}>전송자</span>
            <span className={cx('infoText')}>잡다</span>
          </div>
          <div className={cx('confirmInfoInner')}>
            <span className={cx('infoTitle')}>일시</span>
            <span className={cx('infoText')}>{time}</span>
          </div>
          <div className={cx('confirmInfoInner')}>
            <span className={cx('infoTitle')}>처리 결과</span>
            <span className={cx('infoText')}>{`${noticeTarget} 알림 ${state} 처리 완료`}</span>
          </div>
        </div>
        <div className={cx('line')} />
        <p className={cx('desc')}>{'추후 마이페이지 > 알림관리에서 변경할 수 있습니다.'}</p>
        <button className={cx('btnConfirm')} onClick={onClickCloseBtn}>
          확인
        </button>
      </div>
    </Modal>
  );
};

export default NoticeConfirmModal;
